export default {"src":"/_next/static/media/close-outlined.746b6680.svg","height":18,"width":18};